<template>
  <div class="warpper padding-sm">
    <div class="flex align-center justify-between margin-bottom-sm list-title">
      <b> 短信群发 共{{ list.length }}条</b>
      <router-link to="/branch/message/send" class="add-btn"
                   v-if="user.isBranch">发送短信
      </router-link
      >
    </div>
    <el-skeleton :rows="10" v-if="loading"/>
      <empty v-if="noData" :type="0"/>
    <div class="list-box" v-if="list.length>0">
      <div
        class="item-box margin-bottom-sm"
        v-for="item in list"
        :key="item.id"
      >
        <h3 class="ovHide">{{ item.message }}</h3>
        <div class="flex align-center justify-between item-info">
          <div>
            <p>
              发布时间：{{ item.list[0].create_time |timer }}
              <span class="padding-left">
                                发送人数：
                                <i>{{ item.list.length }}人</i>
                            </span>
            </p>
          </div>
          <div class="right-btn">
            <el-button round class="blue-btn"
                       @click="sendShow(item)"
            >查看
            </el-button>
              <el-button round class="line-btn"
                         @click="delItem(item.id)"
              >删除
              </el-button>
          </div>
        </div>
      </div>
    </div>
    <!--        <div class="flex align-center justify-between" v-if="list.length > 0">-->
    <!--            <span>共{{ total }}条数据</span>-->
    <!--            <el-pagination-->
    <!--                @current-change="getList"-->
    <!--                :current-page.sync="page"-->
    <!--                :page-size="limit"-->
    <!--                layout="prev, pager, next, jumper"-->
    <!--                :total="total"-->
    <!--            >-->
    <!--            </el-pagination>-->
    <!--        </div>-->

    <el-drawer
      title="发送详情"
      :visible.sync="sendListState"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="padding-lr">
        <h3 class="margin-bottom" style="line-height: 200%">
          短信模版：<br/>
          <span class="padding-left"></span>
          {{ sendTemplate }}
        </h3>
        <h3 class="margin-bottom-sm">
          发送会员数量（ <span>{{ sendList.length }}家</span>）
        </h3>
        <div>
          <p v-for="(item, index) in sendList" :key="index" class="margin-bottom-xs">
            {{ index + 1 }}.{{ item.name }} - {{ item.phone }}
          </p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {messageList,delSendSmsLog} from "@/api/branch";
import {zhDate} from "@/utils/utils";

export default {
  name: "list",
  data() {
    return {
      list: [],
      noData: false,
      loading: true,
      sendListState: false,
      direction: 'rtl',
      sendList: [],
      sendTemplate: ''
    }
  },
  created() {
    this.$emit('setIndex', [1, 1], '短信群发')
    this.getList()
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
      //    删除通知公告
      delItem (id) {
          this.$confirm(`此操作将删除该群发记录, 是否继续?`, '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.sureDelete(id)
          })
      },
      async sureDelete (id) {
          let _state = await delSendSmsLog(id)
          if (_state.status === 200) this.$message.success(_state.msg), this.getList()
      },
    //  关闭弹框
    handleClose(done) {
      done();
      this.sendListState = false
      this.sendTemplate = ''
      this.sendList = []
    },
    //  显示发送人员
    sendShow(obj) {
      this.sendTemplate = obj.message
      this.sendList = obj.list
      this.sendListState = true
    },
    //  获取发送记录
    async getList() {
      this.list = []
      this.loading = true
      let _list = await messageList()
      if (_list.status === 0) {
        this.list = []
        this.noData = true
        this.loading = false
      } else {
        this.loading = false, this.noData = false, this.list = _list.data.data, this.total = _list.data.total
        if(_list.data.total === 0){
          this.list = []
          this.noData = true
          this.loading = false
        }
      }
    }
  },
  filters: {
    timer(val) {
      return zhDate(val)
    }
  }

}
</script>

<style scoped lang="scss">
.warpper {
  background: #fff;
  border-radius: 10px;

  .list-title {
    b {
      font-size: 26px;
      line-height: 34px;
    }

    .add-btn {
      display: block;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
      linear-gradient(#0a2240, #0a2240);
      background-blend-mode: normal, normal;
      border-radius: 20px;
      font-size: 16px;
      color: #fff;
    }
  }

  .item-box {
    border-radius: 10px;
    border: solid 1px #dae0e6;

    &:hover {
      background-color: #f3f7fb;
    }

    h3 {
      font-size: 18px;
      line-height: 34px;
      padding: 5px 10px;
      color: #333333;
      font-weight: normal;
        border-bottom: 1px solid #dae0e6;
    }

    .item-info {
      padding: 15px 20px;

      p {
        line-height: 24px;
        font-size: 14px;
          color: #999999;
        i {
          color: #ffb400;
        }
      }
    }

    .right-btn {
      .have-color {
        background: #0a2240;
        border: 0;
      }
    }
  }
}
</style>